import React from 'react';
import { useDispatch } from 'react-redux';

import {
    Heading,
    Paragraph,
    Spacer,
    TextButton,
} from '@zillow/constellation';

import ModalActions from 'app/shared/actions/ModalActions';

// eslint-disable-next-line max-len
const bodyText = "Once a property is created, its unique property address can't be edited. Instead, create a new property with the correct address.";

const AboutAddressEditsModal = () => {
    const dispatch = useDispatch();
    const showCreatePropertyModal = () => {
        dispatch(ModalActions.updateDisplayAddPropertyModal({ isOpen: true, behavior: 'Add' }));
    };

    return (
        <>
            <Heading level={4} fontFamily="serif">The property address can&#39;t be changed</Heading>
            <Spacer marginTop="sm" marginBottom="md">
                <Paragraph>{bodyText}</Paragraph>
            </Spacer>
            <Spacer marginBottom="sm">
                <TextButton onClick={showCreatePropertyModal}>Create a new property</TextButton>
            </Spacer>
        </>
    );
};

export default AboutAddressEditsModal;
